export default __webpack_public_path__ + "static/itsigma-mac-41ee1befe5a6bd6dad0473fe0407637e.png";